import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import discordClone from "../../Assets/discord.png";
import faceDetection from "../../Assets/facedetection.jpg";
import flappyBird from "../../Assets/flappyBird.jpg";
import nta from "../../Assets/networkTrafficAnalyzer.png";
import reactToDoList from "../../Assets/reactToDoList.png";
import spaceInvaders from "../../Assets/spaceInvaders.png";

function Projects() {
  return (
    <Container fluid className="project-section">

      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={discordClone}
              isBlog={false}
              title="Discord Clone"
              description="Discord Clone made using React and Redux. It also uses serverless database, firebase."
              link="https://github.com/MeetRajput00/discord-clone-final"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={faceDetection}
              isBlog={false}
              title="Face Detection AI"
              description="A machine learning model for face detection using Haar Cascade Face Detection."
              link="https://github.com/MeetRajput00/Face-Detection"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={nta}
              isBlog={false}
              title="Network Traffic Analyzer"
              description="A Network Traffic Analyzer which displays the packets of the network it's connected to. It's made using .NET framework in C# language."
              link="https://github.com/MeetRajput00/network-traffic-analyzer"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={flappyBird}
              isBlog={false}
              title="Flappy Bird"
              description="Clone of the famous Flappy Bird game using Python's pygame module."
              link="https://github.com/MeetRajput00/Flappy-Bird"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={spaceInvaders}
              isBlog={false}
              title="Space Invaders"
              description="Clone of space invaders using python's pygame module."
              link="https://github.com/MeetRajput00/SpaceInvaders"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={reactToDoList}
              isBlog={false}
              title="React To-Do List"
              description="A simple to-do list made using ReactJS."
              link="https://github.com/MeetRajput00/react-todolist"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
